import React from "react";

export default function LoadingOrbit({
  message = "Calculating risk exposure...",
  submessage = "Running FAIR simulation",
}) {
  return (
    <div className="flex min-h-[700px] flex-col items-center justify-center  p-10 shadow-sm">
      <div className="relative h-24 w-24 animate-spin">
        {[0, 1, 2, 3, 4, 5, 6, 7].map((dot) => {
          const size = 18 - dot * 1.4;
          const angle = dot * 45;

          return (
            <span
              key={dot}
              className="absolute left-1/2 top-1/2 rounded-full bg-cyan-700"
              style={{
                width: `${size}px`,
                height: `${size}px`,
                transform: `rotate(${angle}deg) translate(38px)`,
                transformOrigin: "0 0",
                opacity: 1 - dot * 0.08,
              }}
            />
          );
        })}
      </div>

      <div className="mt-6 text-center">
        <p className="text-sm font-semibold text-slate-900">
          {message}
        </p>
        <p className="mt-1 text-xs text-slate-500">
          {submessage}
        </p>
      </div>
    </div>
  );
}